/* eslint-disable max-lines-per-function */
// import { getElementMaximumHeight } from '@/utils/Utils';
import React, { JSX, useEffect, useState } from 'react';
import Styles from './exsistingSubscription.module.scss';
import { getElementMaximumHeight } from '../../utils/utils';

interface ExistingSubscriptionSchema {
  name?: string;
  subscriptionData: any;
  cardIndex?: any;
  updateBorderMethod?: (key?: number) => void;
  selectedCardIndex?: number;
  subscriptionCardsLength?: any;
}

const ExistingSubscriptionCards = ({
  subscriptionData,
  cardIndex,
  updateBorderMethod,
  selectedCardIndex,
  subscriptionCardsLength,
}: ExistingSubscriptionSchema): JSX.Element => {

  const [selectCard, setSelectCard] = useState(true);

  const handleSelectedSubscription = () => {
    if (selectedCardIndex === cardIndex && selectCard) {
      updateBorderMethod && updateBorderMethod(undefined);
      setSelectCard(false);
    } else {
      updateBorderMethod && updateBorderMethod(cardIndex);
      setSelectCard(true);
    }
  };

  const findHeight = () => {
    getElementMaximumHeight('title', subscriptionCardsLength);
    getElementMaximumHeight('description', subscriptionCardsLength);
    getElementMaximumHeight('subPreviewFooter', subscriptionCardsLength);
  };

  useEffect(() => {
    findHeight();
    window.addEventListener('resize', findHeight);
  }, [subscriptionCardsLength]);

  return (
    <React.Fragment>
      <div
        className={`${subscriptionCardsLength === 1 ? Styles.cardsWidthOne : Styles.cardsWidth} `}
      >
        <div onClick={() => handleSelectedSubscription()}>
          <div
            className={`${
              selectCard && selectedCardIndex === cardIndex ? Styles.gradientborder : Styles.cardtype
            } ${Styles.cardsPaddingAdd}`}
          >
            <div className='d-block'>
              <div className={`${Styles.subscriptionTitle}`} id={`title${cardIndex}`}>
                {subscriptionData?.ratePlan}
              </div>
              <div
                className={`${Styles.subscriptionDescription}`}
                id={`description${cardIndex}`}
                data-hj-suppress
              >
                {subscriptionData?.msisdn}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
export default ExistingSubscriptionCards;
